import getDistanceFromLatLonInKm from "./getDistanceFromLatLonInKm"

const zoomMapToCenters = function (placeSelected, centerInformation, centersToDisplay) {
  const maxFilteredCentersToDisplay = centersToDisplay ?? 3
  const hasSelectedPlace = !!placeSelected
  const hasGeometry = hasSelectedPlace && placeSelected.geometry

  if (hasGeometry) {
    return centerInformation
      .sort((centerA, centerB) => {
        return (
          getDistanceFromLatLonInKm(placeSelected, centerA) -
          getDistanceFromLatLonInKm(placeSelected, centerB)
        )
      })
      .slice(0, maxFilteredCentersToDisplay)
  }
}

export default zoomMapToCenters
